import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from 'services/role.service';
import { RouterDataResolver } from 'services/router.resolver';
import { tenantType, tenantTypeCap, RolePermissionType, PermissionAccessType, TenantTypeName } from 'shared/constant';
import { environment } from '../../../../environments/environment';
import { AccountService } from '../../../api-services';
import { AuthService, SharedService } from '../../../services';
import { Package } from 'models/packages/package.model';
import { PackageCommonService } from '../../../services/package-common.service';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RemindersService } from 'api-services/reminders.service';
import { ChatService } from '../../../api-services/chat.service';
import { PaymentService } from '../../../api-services/payment.service';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  name: string
  shortName: string
  pageTitle = ''
  breadcums = ''
  activeIcon = '';
  showIcon = true;
  isContactUser = false;
  isGuestUser = false;
  isOnboardingUser = false;
  hideSideBar = false;
  tenantTypeId = localStorage['tenantTypeId'];
  tenantType = tenantType;
  tenantTypeName = TenantTypeName;
  isHelp: boolean = window.location.href.includes("/help-center");
  totalFileCount: number;
  profileStatus = localStorage["profileStatus"];
  package = this.packageCommonService.getPackageLocalStorage();
  email: string;
  isAIPopupOpened: boolean = false;
  showReminderPannel: boolean = false;
  remiderCount: number = JSON.parse(localStorage.getItem("remiderCount") || "0");
  reminderDetails = null;
  showUserReminderPannel: boolean = false;
  showHelpAndFeedbackPannel: boolean = false;
  aiEnabled: boolean = false;
  isDownliningPermitted : boolean = false;
  isAccountOwner = false;
  hideDownliningTitle = false;
  contactInfo : any;
  subscription: Subscription[] = [];
  downliningtenantTypeId = localStorage['downlining-tenantTypeId'];
  downliningLicenseListingType = localStorage['downlining-licenseListType'];
  downliningAppointmentListingType = localStorage['downlining-appointmentListType'];
  isIndividualUser = false;
  isVisibleContent: boolean = environment.isVisible;
  isAccountOnwer: boolean = false;
  isAdminUser: boolean = false;
  showAchPopup = false;
  pendingSetupIntentId = '';
  verificationURL: string = '';
  setupIntentId: string = '';
  isBillingInfoPermitted: boolean = false;

  @ViewChild('openachPopup') openachPopupEle: ElementRef;
  @ViewChild('closeachPopup') closeachPopupEle: ElementRef;
  
  private packageEventSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private accountService: AccountService,
    private roleService: RoleService,
    private routerDataResolver: RouterDataResolver,
    private sharedService: SharedService,
    private modalService: NgbModal,
    private packageCommonService: PackageCommonService,
    private remindersService: RemindersService,
    private chatService: ChatService,
    private authService: AuthService,
    private paymentService: PaymentService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.isIndividualUser = this.roleService.isIndividualUser;
    if (routerDataResolver.pageName == 'Downlining'){
      this.isAccountOwner = this.roleService.isTenantOwnerUser;
      this.isDownliningPermitted = this.roleService.isFeatureAccessible(RolePermissionType.Downlining, PermissionAccessType.Yes);
      if (this.isDownliningPermitted == false && this.isAccountOwner == false) {
        // this.router.navigate(['/dashboard'])
        this.hideDownliningTitle = true;
      }
    }
      this.pageTitle = routerDataResolver.pageName;
      this.breadcums = routerDataResolver.breadcrumb;
      this.activeIcon = routerDataResolver.pageIcon;
      this.hideSideBar = routerDataResolver.hideSideBar;
      this.sharedService.AllReminderVisibility$.subscribe(isVisible => {
        this.showReminderPannel = isVisible;
      });
      this.sharedService.IssueAndFeedbackVisibility$.subscribe(isVisible => {
        this.showHelpAndFeedbackPannel = isVisible;
      })
    if (!this.isIndividualUser) {
      this.remindersService.getupdateReminder$.subscribe(isUpdate => {
        this.getRemindersCount();
      });
    }
      this.chatService.canMakeRequest().subscribe(
        (response: any) => {
          this.aiEnabled = response;
        }
    )
  }


  ngOnInit(): void { 
        if(this.hideDownliningTitle)
        {
          this.router.navigate(['/dashboard'])
        }

        this.isAccountOnwer = this.roleService.isTenantOwnerUser;
        this.isAdminUser = this.roleService.isAdminUser;
        this.isContactUser = this.roleService.isContactUser;
        this.isGuestUser = this.roleService.isGuestUser;
        this.isOnboardingUser = this.roleService.isOnboardingUser;
        this.isBillingInfoPermitted = this.roleService.isFeatureAccessible(RolePermissionType.BillingInformationDetails, PermissionAccessType.Yes);
       

        localStorage.hasOwnProperty('agenzeeAI') ? this.isAIPopupOpened = JSON.parse(localStorage['agenzeeAI']) : '';
        if (this.sharedService.getValue('name')) {
          this.name = this.sharedService.getValue('name');
          this.shortName = this.name.split(' ').map(n => n[0]).join('');
          // if(this.isGuestUser)
            this.email = this.sharedService.getValue('emailId');
        }

        if(this.router.url == "/errors-omissions/user/add-eando" || this.router.url == "/errors-omissions/user/add-bond" || this.router.url == "/errors-omissions/user" || this.router.url == "/firm-dashboard/background-question" )
        {
          this.setBranchName();
        }
        // this.getRemindersCount();

        this.sharedService.getUpdate().subscribe
          (res => { //message contains the data sent from service
            if (this.router.url == "/contact-dashboard" && this.isContactUser){
              this.setContactUserDashboardVal();
            }
            else if(this.router.url == "/dashboard/agent-scorecard")
              this.breadcums = ' / Scorecard / ' + JSON.parse(localStorage.getItem('selContact'))?.displayName + '';
            else if (this.router.url == "/contact-dashboard/scorecard")
              this.breadcums = ' / Scorecard ';
            else if (this.router.url == "/contact-dashboard/detail-scorecard")
              this.breadcums = ' / Scorecard / ' + JSON.parse(localStorage.getItem('selContact'))?.customGroupName;
            else if (this.router.url == "/contact-dashboard/affiliations")
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('userProfile'))?.name;
            else if (this.router.url == "/contact-list")
              this.pageTitle = tenantTypeCap[this.tenantTypeId] + "s";
            else if (window.location.href.includes("/notes")) {
              var name = localStorage.getItem('seleNotesEntity');
              this.breadcums = ' / ' + (name == undefined ? '' : name) + ' / Notes';
            } else if (this.router.url == "/contact-list/ce-credits" || this.router.url == "/contact-list/ce-credits#contracting") {
              if(this.isContactUser){
                this.setContactUserDashboardVal(' / CE ')
              }
              else { var name = localStorage.getItem('seleCEUser');
                this.breadcums = ' / ' + (name == undefined ? '' : name + ' / CE ');
              }
            } 
            else if (this.router.url == "/custom-loa-group-list/branch") {
            }
            else if (this.router.url == "/contact-list/healthcare-info") {
              if(this.isContactUser){
                this.setContactUserDashboardVal(' / Agent and Broker Federally-facilitated Marketplace Information ')
              }
              else {
                var name = localStorage.getItem('seleCEUser');
                this.breadcums = ' / ' + (name == undefined ? '' : name + ' / Agent and Broker Federally-facilitated Marketplace Information');
              }
            }
            else if (this.router.url == "/custom-loa-group-list/branch") {
              this.breadcums = ' / ' + (this.tenantTypeId == 3 ? 'Custom Groups By Branch' : 'Custom Groups By Agency');
            } else if (window.location.href.includes("/bulk-licenses-renewal-user")) {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('licenseActiveContactUser'))?.userName;
            }
            else if (this.router.url == "/contracting/new-contract/contract-request") {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('package'))?.name + ' / New Appointment';
            }
            else if (this.router.url == "/contracting/new-contract/contract-termination-request") {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('package'))?.name + ' / Appointment Termination';
            }
            else if (this.router.url == "/contracting/contract/review-contract") {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('package'))?.name;
            }
            else if (this.router.url == "/contracting/new-contract/contract-detail" || this.router.url == "/contracting-carrier/contract-list") {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('package'))?.name;
            }
            else if (this.router.url == "/downlining/company-list" && (this.isDownliningPermitted || this.isAccountOwner)) {
              this.breadcums = ' / ' + localStorage.getItem('selDownlineName');
            }
            else if (this.router.url == "/downlining/contact-license-list") {
              this.downliningLicenseListingType == 'expire' ? this.breadcums = ' / ' + localStorage.getItem('selDownlineName') + ' / ' + localStorage.getItem('downlining-selectedProducerName') + ' / ' + 'Licenses' + ' (Expiring in 90 Days)' : this.breadcums = ' / ' + localStorage.getItem('selDownlineName') + ' / ' + localStorage.getItem('downlining-selectedProducerName') + ' / ' + 'Licenses';
            }
            else if (this.router.url == "/downlining/contact-appointment-list") {
              this.downliningAppointmentListingType == 'expire' ? this.breadcums = ' / ' + localStorage.getItem('selDownlineName') + ' / ' + localStorage.getItem('downlining-selectedProducerName') + ' / ' + 'Appointments' + ' (Expiring in 30 Days)' : this.breadcums = ' / ' + localStorage.getItem('selDownlineName') + ' / ' + localStorage.getItem('downlining-selectedProducerName') + ' / ' + 'Appointments';
              // this.breadcums = ' / ' + localStorage.getItem('selDownlineName') + ' / ' + 'Appointments' + this.downliningAppointmentListingType == 'expire' ? ' (Expiring in 30 Days)' : '';
            }
            else if (this.router.url == "/downlining/contact-dashboard")
              this.pageTitle = tenantTypeCap[this.downliningtenantTypeId] + " Dashboard";

            // else if (this.router.url == "/onboarding/onboarding-dashboard" || this.router.url == "/onboarding/onboarding-user-dashboard") {
            //   if (this.isOnboardingUser) {
            //     this.breadcums = ' / ' + this.name;
            //   } else {
            //     this.breadcums = ' / ' + JSON.parse(localStorage.getItem('activeOnboardingUser'))?.displayName;
            //   }
            // }
            // else if (this.router.url == "/onboarding/user-pdb-information") {
            //   this.breadcums = ' / ' + JSON.parse(localStorage.getItem('activeOnboardingUser'))?.niprFirstName + ' ' + JSON.parse(localStorage.getItem('activeOnboardingUser'))?.niprLastName;
            // }
            else if (this.router.url == "/onboarding/onboarding-dashboard/employment-history")
              if (this.isOnboardingUser) {
                this.breadcums = ' / ' + this.name + ' / ' + 'Employment History';
              } else {
                this.breadcums = ' / ' + JSON.parse(localStorage.getItem('activeOnboardingUser'))?.displayName + ' / ' + 'Employment History';
              }
            else if (this.router.url == "/onboarding/onboarding-dashboard/background-question")
              if (this.isOnboardingUser) {
                this.breadcums = ' / ' + this.name + ' / ' + 'Background Questions';
              } else {
                this.breadcums = ' / ' + JSON.parse(localStorage.getItem('activeOnboardingUser'))?.displayName + ' / ' + 'Background Questions';
              }
            else if (this.router.url == "/onboarding/onboarding-dashboard/policy-form")
              if (this.isOnboardingUser) {
                this.breadcums = ' / ' + this.name + ' / ' + JSON.parse(localStorage.getItem('userFile_Form'))?.documentName;
              } else {
                this.breadcums = ' / ' + JSON.parse(localStorage.getItem('activeOnboardingUser'))?.displayName + ' / ' + JSON.parse(localStorage.getItem('userFile_Form'))?.documentName;
              }
            else if (this.router.url == "/onboarding/onboarding-dashboard/form")
              if (this.isOnboardingUser) {
                this.breadcums = ' / ' + this.name + ' / ' + JSON.parse(localStorage.getItem('userFile'))?.documentName;
              } else {
                this.breadcums = ' / ' + JSON.parse(localStorage.getItem('activeOnboardingUser'))?.displayName + ' / ' + JSON.parse(localStorage.getItem('userFile_Form'))?.documentName;
              }
            else if (this.router.url == "/contact-dashboard/documents" || this.router.url == "/contact-list/documents") {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('userProfile'))?.name + ' / ' + 'Documents';
            }
            else if (this.router.url == "/contact-dashboard/employment-history" || this.router.url == "/contact-list/employment-history") {
              this.isContactUser ? 
              this.setContactUserDashboardVal(' / Employment History')
              : this.breadcums = ' / ' + JSON.parse(localStorage.getItem('userProfile'))?.name + ' / ' + 'Employment History';
            }
            else if (this.router.url == "/contact-dashboard/background-question" || this.router.url == "/contact-list/background-question") {
              this.isContactUser ? 
              this.setContactUserDashboardVal(' / Background Questions') 
              : this.breadcums = ' / ' + JSON.parse(localStorage.getItem('userProfile'))?.name + ' / ' + 'Background Questions';
            }
             else if (this.router.url == "/agency-onboarding/onboarding-dashboard/background-question") {
              this.isContactUser ? 
              this.setContactUserDashboardVal(' / Background Questions') 
              : this.breadcums = ' / ' + JSON.parse(localStorage.getItem('activeOnboardingUser'))?.firstName + ' / ' + 'Background Questions';
            }

            else if(this.router.url == "/firm-dashboard/background-question"){
              var branchName = localStorage.getItem('activeContactBranchName');
              this.breadcums = ' / ' + branchName + ' / ' + 'Background Questions';
            }
            else if (this.router.url == '/manage/agencies/background-question' || this.router.url == '/manage/branches/background-question' || this.router.url == "/firm-dashboard/background-question"){
              this.breadcums = ' / ' + localStorage.getItem('selectedBranchName') + ' / ' + 'Background Questions';
            }
            else if (this.router.url == '/manage/agencies/documents' || this.router.url == '/manage/branches/documents' || this.router.url == '/firm-dashboard/documents'){
              this.breadcums = ' / ' + localStorage.getItem('selectedBranchName') + ' / ' + 'Documents';
            }
            else if (this.router.url == "/contact-list/manual-license") {
              if (localStorage.getItem('selectedFinraUserLicenseId') != null) {
                this.pageTitle = "Edit Manual License";
              }
            }
            else if (this.router.url == "/contact-dashboard/non-background-question") {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('userProfile'))?.name + ' / ' + 'Non Background Questions';
            }
            else if (this.router.url == "/onboarding/onboarding-dashboard/non-background-question") {
              if (this.isOnboardingUser) {
                this.breadcums = ' / ' + this.name + ' / ' + 'Non Background Questions';
              } else {
                this.breadcums = ' / ' + JSON.parse(localStorage.getItem('activeOnboardingUser'))?.displayName + ' / ' + 'Non Background Questions';
              }
            }
             else if ((this.router.url == "/errors-omissions/user" && this.contactInfo?.isTypeFirm != true)) {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('userProfile'))?.name ;
            }
            else if (this.router.url.includes("/errors-omissions/user#contracting" )) {
              var name = window.location.hash?.split('-')[2] + ' ' + window.location.hash?.split('-')[3]
              this.breadcums = ' / ' +  name;
            }
            else if (this.router.url.includes("/contact-list/ce-creditsr#contracting")) {
              var name = window.location.hash?.split('-')[2] + ' ' + window.location.hash?.split('-')[3]
              this.breadcums = ' / ' +  name;
            }
             else if (this.router.url == "/errors-omissions/user" && this.contactInfo?.isTypeFirm == true) {
              this.breadcums = ' / ' + this.contactInfo?.branchName ;
            }
            else if (this.router.url == "/errors-omissions/user/add-eando" && this.contactInfo?.isTypeFirm != true ) {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('userProfile'))?.name + ' / ' + 'Add E&O';
            }
            else if (this.router.url == "/errors-omissions/user/add-bond"  && this.contactInfo?.isTypeFirm != true) {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('userProfile'))?.name + ' / ' + 'Add Bond';
            }
            else if (this.router.url == "/errors-omissions/user/add-eando"  && this.contactInfo?.isTypeFirm == true ) {
              this.breadcums = ' / ' + this.contactInfo?.branchName + ' / ' + 'Add E&O';
            }
            else if (this.router.url == "/errors-omissions/user/add-bond"  && this.contactInfo?.isTypeFirm == true) {
              this.breadcums = ' / ' + this.contactInfo?.branchName + ' / ' + 'Add Bond';
            }
            else if (this.router.url == "/main-licenses/bulk-licenses-renewal" 
              || this.router.url == "/main-licenses/bulk-licenses-renewal-list"
              || this.router.url == "/bulk-licenses-renewal/request-status" 
              // || this.router.url == "bulk-licenses-renewal/bulk-eligibility-status"
              || this.router.url == "/main-licenses/bulk-eligibility-status"
              || this.router.url == "/main-licenses/bulk-licenses-renewal/solo-producer-request-status"
              || this.router.url == "/main-licenses/bulk-licenses-renewal/bulk-renewal-estimated-fee-summary")
            {
              this.pageTitle = localStorage.getItem('renewalType') == 'single' ? 'License Renewal' : 'Bulk License Renewal' ;
            } 
            else if (this.router.url == "/main-appointments/bulk/carrier-list" || this.router.url == "/main-appointments/bulk-appointment-user" ) {
              this.breadcums = ' / ' + localStorage.getItem('BulkAppointmentSelectedUserName');
            }
            else if (this.router.url == "/contact-dashboard/eft") {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('userProfile'))?.name + ' / ' + 'EFT';
            }
            else if (this.router.url == "/main-appointments/bulk-appointment-termination"|| this.router.url == "/main-appointments/bulk-appointment-termination-appointment-list"  || this.router.url == "/main-appointments/bulk-appointment-termination-appointer-list") {
              this.breadcums = ' / ' + JSON.parse(localStorage.getItem('bulkAppointmentTerminationSelectedUser'))?.displayName;
            }
          });

        this.packageEventSubscription = this.packageCommonService.packageStatusUpdateObs.subscribe(() => {
          this.package = this.packageCommonService.getPackageLocalStorage();
          this.breadcums = ' / ' + this.package.name;
        });

    //this.checkAchVerificationPopup();
  }

  checkAchVerificationPopup() {
    this.paymentService.getPendingAchVerification()
      .subscribe(
        result => {
          if (result && result.status === 'requires_action')
          {
            this.verificationURL = result.verificationUrl;
            this.setupIntentId = result.setupIntentId;
            this.handleAchPopup();
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  handleAchPopup()
  {
    const key = `ach_popup_${this.setupIntentId}`;

    const today = new Date().toISOString().split('T')[0];

    const lastShown = localStorage.getItem(key);

    if (lastShown !== today)
    {
      this.openachPopupEle.nativeElement.click();
      this.pendingSetupIntentId = this.setupIntentId;
      localStorage.setItem(key, today);
    }
  }

  verifyLater() {
    const customerName = this.sharedService.getValue('name');

    this.paymentService.createPaymentActivityAuditLog({
      paymentActivityTypeId: 2,
      eventType: 'verify_declined', 
      logDescription: `Verify declined by ${customerName}`
    }).toPromise();

    this.closePopup();
  }

  async verifyNow() {
    if (this.verificationURL) {
      const result = await this.paymentService.checkAchStatus(this.setupIntentId).toPromise();

      if (result.status === 'succeeded') {
        this.verificationURL = '';
      }
      else {
        const customerName = this.sharedService.getValue('name');

        this.paymentService.createPaymentActivityAuditLog({
          paymentActivityTypeId:  2,
          eventType: 'verify_initiate',
          logDescription: `Verify initiate by ${customerName}`
        }).toPromise();

        window.open(
          this.verificationURL,
          '_blank'
        );
      }

      this.closePopup();
    }
  }

  

  closePopup() {
    this.closeachPopupEle.nativeElement.click();
  }


  // @ViewChild('reminder') public reminderContainer: ElementRef;

  // @HostListener('document:click', ['$event'])
  // handleOutsideClick(event: Event) {
  //   if ((this.reminderContainer.nativeElement !== event.target && 
  //     !this.reminderContainer.nativeElement.contains(<HTMLInputElement>event.target)) &&
  //     !event.target['classList'].contains('ng-option-label')) {  
  //     this.hideReminder(event);
  //   } 
  // }

  setBranchName(){
    this.subscription.push(this.sharedService.sharedRequestData.subscribe(res => {
      this.contactInfo = res;
    }));
  }

setContactUserDashboardVal(breadcrumb = null){
    this.pageTitle = 'Dashboard';
    this.activeIcon = 'ic-dashboard.svg'
    this.breadcums = breadcrumb
  }
  
  toggleSideBar() {
    document.body.classList.toggle('sb-sidenav-toggled');
  }

  logout(): void {
    this.authService.userLoggedOut();
    this.accountService.logout();
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 50);
  }

  redirectToHomePage() {
    if (this.isContactUser && !this.isOnboardingUser) {
      this.router.navigate(["/contact-dashboard"])
    }
    else if (this.isGuestUser) {
      this.router.navigate(["/contracting-carrier"])
    }
    else if (this.isOnboardingUser) {
      this.router.navigate(["/onboarding-dashboard"])
    }
    else if (localStorage["userRole"] == "admin") {
      this.router.navigate(["/dashboard"])
    }
    else {
      if (JSON.parse(localStorage.getItem('profileStatus')) >= 5) {
        this.router.navigate(["/dashboard"]);
      }
    }

    //if (JSON.parse(localStorage.getItem('profileStatus')) >= 4){
    // if (this.isContactUser) {
    //   this.router.navigate(["/dashboard-tech"])
    // } else {
    //   this.router.navigate(["/dashboard"])
    // }
    //}
    // else if (JSON.parse(localStorage.getItem('profileStatus')) == 0)
    //   this.router.navigate(['/product-plan']);
    // else if (JSON.parse(localStorage.getItem('profileStatus')) == 1)
    //   this.router.navigate(['/domain']);
    // else if (JSON.parse(localStorage.getItem('profileStatus')) == 2)
    //   this.router.navigate(['/niprcred']);
    // else if (JSON.parse(localStorage.getItem('profileStatus')) == 3)
    //   this.router.navigate(['/npn']);
    // else {

    // }

  }

  redirectToHelp() {
    window.open(`/help`, '_blank');
    // this.router.navigateByUrl('/help');
    // this.router.navigateByUrl("/help", { skipLocationChange: true });
  }

  redirectToNewHelp() {
    window.open(`/help-center`, '_blank');
  }

  getPackageStatus(_package: Package) {
    if (_package?.statusId == 2)
      return 'New';
    else {
      return _package.status;
    }
  }

isReminder = false;
  showReminder(event) {
    event.stopPropagation();
    this.isReminder = !this.isReminder;
    this.sharedService.setAllReminderVisibility(this.isReminder);
    this.sharedService.setUserReminderVisibility(false);
    this.sharedService.setIssueAndFeedbackVisibility(false);
  }

  hideReminder(event) {
    this.sharedService.setAllReminderVisibility(false);
    this.isReminder = false;
  }

  getRemindersCount(){
    this.remindersService.getRemindersCount(JSON.parse(this.sharedService.getValue('userId'))).subscribe(res => {
      this.remiderCount = res;
      localStorage.setItem('remiderCount', res);
    })
  }
 
  showIssueandFeedback(event, tabId) {
    this.sharedService.changeTab(tabId);
    event.stopPropagation();
    
    localStorage.setItem('fs', tabId);
    this.sharedService.setIssueAndFeedbackVisibility(true);
    this.sharedService.setAllReminderVisibility(false);
    this.isReminder = false;
    this.sharedService.setUserReminderVisibility(false);

    

    const target = event.target as HTMLElement;
    const dropdownMenu = target.closest('.dropdown-menu');
  
    if (dropdownMenu.classList.contains('show')) {
      dropdownMenu.classList.remove('show');
    }
  }

  
  hideIssueAndFeedback(event) {
    this.sharedService.setIssueAndFeedbackVisibility(false);
  }

  agenzeeAIModal(){
    this.isAIPopupOpened = !this.isAIPopupOpened;
    localStorage.setItem("agenzeeAI", JSON.stringify(this.isAIPopupOpened))
    // const modalRef = this.modalService.open( ChatComponent, ngbModalOptionsLG);
    // // modalRef.componentInstance.data = data;

    // modalRef.result.then((data) => {
    //   if (data) {
    //     this.isAIPopupOpened = false;
    //   }
    // });
  }

  ngAfterViewInit() {
    this.sharedService.changeEmailValue.subscribe((res) => {
       this.email = res
    });
  }

  ngDestroy() {
    this.packageEventSubscription.unsubscribe();
  }
}
